export const TERM_MODEL_TYPE = {
    MD_THIET_BI: "dmthietbi",
    DM_NGUON_THANH_TOAN: "dmnguonthanhtoan",
    DM_CAU_HINH_PHAT_LOA: "dmcauhinhphatloa",
    TAB_KHAM_BENH_KHAM_DOAN: "tabKhamBenhKhamDoan",
};